import { render, staticRenderFns } from "./shopsRsGoodsList_ec.vue?vue&type=template&id=f78bfa12&scoped=true&"
import script from "./shopsRsGoodsList_ec.vue?vue&type=script&lang=js&"
export * from "./shopsRsGoodsList_ec.vue?vue&type=script&lang=js&"
import style0 from "./shopsRsGoodsList_ec.vue?vue&type=style&index=0&id=f78bfa12&lang=less&scoped=true&"
import style1 from "./shopsRsGoodsList_ec.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f78bfa12",
  null
  
)

component.options.__file = "shopsRsGoodsList_ec.vue"
export default component.exports